import { useQuery } from "@tanstack/react-query";
import {
  AddProductCode,
  GenerateProductCode,
  ListCodesProduct,
  ProductCode,
} from "../../services/services";
import React, { useRef, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import Loading from "../../components/Loading/Loading";
import PersianDate from "../../components/PersianDate/PersianDate";
import TextField from "../../components/Textfield/TextField";
import { SidebarLeft } from "../../components/SidebarLeft/SidebarLeft";
import addIcon from "../../svg/addIcon.webp";
import arrowIcon from "../../svg/arrowIcon.svg";
import SidebarLeftAddCategoryCode from "./SidebarLeftAddCategoryCode";
import { InputNumber } from "primereact/inputnumber";
import { SelectCustom } from "../../components/SelectCustom/SelectCustom";
import Button from "../../components/Button/Button";
import { Toast } from "primereact/toast";

const GenerateCell = ({ rowId, codeCounts, setCodeCounts, onGenerate }) => {
  const value = codeCounts[rowId] ?? 0;
  const countNum = Number(value);
  const isValid = Number.isFinite(countNum) && countNum > 0;

  return (
    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
      <InputNumber
        value={value}
        onValueChange={(e) => {
          setCodeCounts((prev) => ({
            ...prev,
            [rowId]: e.value ?? 0,
          }));
        }}
        min={0}
        inputStyle={{ width: 90, height: 34 }}
      />

      <button
        type="button"
        disabled={!isValid}
        className="btn btn-success d-flex align-items-center justify-content-center"
        style={{ width: 36, height: 34, padding: 0 }}
        title="ایجاد"
        onClick={() => onGenerate(rowId, countNum)}
      >
        ✓
      </button>
    </div>
  );
};

const Code = () => {
  const [filtersProductCode, setFiltersProductCode] = useState({
    pageSize: 18,
    pageNumber: 1,
  });
  const [sidebarLeftShow, setSidebarLeftShow] = useState(false);
  const [codeCounts, setCodeCounts] = useState({});
  const [filtersListCodesProduct, setFiltersListCodesProduct] = useState({
    pageSize: 18,
    pageNumber: 1,
    Code: "",
    IsUsed: undefined,
    ProductCodeId: undefined,
  });
  const [selectedCategoryTitle, setSelectedCategoryTitle] = useState("");
  const [expandedRows, setExpandedRows] = useState({});
  const [selectedRow, setSelectedRow] = useState(null);
  const toast = useRef(null);
  const showSuccess = (msg) =>
    toast.current?.show({
      severity: "success",
      summary: "موفق",
      detail: msg,
      life: 2000,
    });

  const {
    data: productCode,
    isLoadingl,
    refetch: refetchProductCode,
  } = useQuery({
    queryKey: ["ProductCode", filtersProductCode],
    queryFn: () => ProductCode(filtersProductCode),
    retry: false,
  });

  const { data: listCodesProduct, refetch: refetchListCodesProduct } = useQuery(
    {
      queryKey: [
        "ListCodesProduct",
        filtersListCodesProduct.pageNumber,
        filtersListCodesProduct.pageSize,
        filtersListCodesProduct.Code,
        filtersListCodesProduct.IsUsed,
        filtersListCodesProduct.ProductCodeId,
      ],
      queryFn: () =>
        ListCodesProduct({
          pageSize: filtersListCodesProduct.pageSize,
          pageNumber: filtersListCodesProduct.pageNumber,
          Code: filtersListCodesProduct.Code,
          IsUsed: filtersListCodesProduct.IsUsed,
          ProductCodeId: filtersListCodesProduct.ProductCodeId,
        }),
      retry: false,
    }
  );

  const handleGenerateClick = (productCodeId, count) => {
    if (!Number.isFinite(count) || count <= 0) return;

    GenerateProductCode(productCodeId, count)
      .then(
        (response) => showSuccess("کدها با موفقیت اضافه شد "),
        refetchListCodesProduct()
      )
      .catch((error) => console.error("Error generating product code", error));
  };

  const handlePageChange = (e) => {
    setFiltersListCodesProduct((prevFilters) => ({
      ...prevFilters,
      pageNumber: e.page + 1,
      pageSize: e.rows,
    }));
  };

  const handleSearchClick = () => {
    setFiltersListCodesProduct((prevFilters) => ({
      ...prevFilters,
      pageNumber: 1,
    }));
  };
  const productCodeWithCount =
    productCode?.items?.map((item) => ({
      ...item,
      _count: codeCounts[item.id] ?? 0,
    })) ?? [];
  const getRowClass = (rowData) => {
    return rowData.id === selectedRow ? "selected-row" : "";
  };

  const productCodeOptions =
    productCode?.items?.map((item) => ({
      label: item.title,
      value: item.id,
    })) ?? [];

  const isUsedOptions = [
    { label: "استفاده شده", value: true },
    { label: "استفاده نشده", value: false },
  ];

  return (
    <div className="list-user">
      <Toast ref={toast} position="top-center" />
      <div className="row">
        <div className="col-3 card">
          <div
            style={{
              alignItems: "center",
              placeItems: "center",
              display: "flex",
            }}
          >
            <h5> دسته های کد </h5>
            <button
              style={{
                border: "1px solid #000",
                borderRadius: "50%",
                width: "28px",
                height: "28px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginRight: "10px",
                marginBottom: "8px",
              }}
              onClick={() => setSidebarLeftShow(true)}
            >
              <img src={addIcon} width={28} alt="add" />
            </button>
          </div>
          <DataTable
            value={productCodeWithCount}
            paginator
            lazy
            rows={filtersProductCode.pageSize}
            totalRecords={productCode?.totalCount}
            first={
              (filtersProductCode.pageNumber - 1) * filtersProductCode.pageSize
            }
            rowClassName={getRowClass}
            onRowClick={(e) => {
              const rowId = e.data.id;
              setSelectedRow(rowId);
              setSelectedCategoryTitle(e.data.title);

              setFiltersListCodesProduct((prevFilters) => ({
                ...prevFilters,
                ProductCodeId: rowId,
                pageNumber: 1,
              }));

              if (expandedRows[rowId]) {
                setExpandedRows({});
              } else {
                setExpandedRows({ [rowId]: true });
              }
            }}
            dataKey="id"
            stripedRows
            className="farsi-monospace-digit"
          >
            <Column
              body={(rowData) => (
                <div
                  style={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  <img
                    src={arrowIcon}
                    style={{ transform: "rotate(180deg)" }}
                    width={14}
                  />
                  <span>{rowData?.title}</span>
                </div>
              )}
              field="title"
              header="عنوان"
            />
            <Column
              header="ساخت کد قرعه‌کشی"
              body={(rowData) => (
                <GenerateCell
                  rowId={rowData.id}
                  codeCounts={codeCounts}
                  setCodeCounts={setCodeCounts}
                  onGenerate={handleGenerateClick}
                />
              )}
            />
          </DataTable>
        </div>
        <div style={{ marginRight: "10px" }} className="col-8 card">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <div
              onClick={() => (
                setFiltersListCodesProduct({
                  ...filtersListCodesProduct,
                  ProductCodeId: null,
                }),
                setSelectedCategoryTitle("")
              )}
            >
              <img
                src={arrowIcon}
                style={{ transform: "rotate(180deg)" }}
                width={22}
              />
            </div>
            <h5 style={{ display: "flex", alignItems: "center" }}>
              کدها
              {selectedCategoryTitle && (
                <span
                  style={{
                    color: "#666",
                    fontSize: "14px",
                    marginRight: "8px",
                  }}
                >
                  ({selectedCategoryTitle})
                </span>
              )}
            </h5>
          </div>
          <div
            className="row mt-4"
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <div className="col-3">
              <TextField
                style={{ height: "40px" }}
                value={filtersListCodesProduct.Code}
                label={"کد"}
                onChange={(e) =>
                  setFiltersListCodesProduct({
                    ...filtersListCodesProduct,
                    Code: e.target.value,
                  })
                }
              />
            </div>
            <div className="col-3">
              <SelectCustom
                name="ProductCodeId"
                placeholder="دسته کد"
                isClearable={true}
                isSearchable={false}
                unstyled={true}
                options={productCodeOptions}
                value={
                  productCodeOptions.find(
                    (item) =>
                      item.value === filtersListCodesProduct.ProductCodeId
                  ) || null
                }
                onChange={(e) => {
                  setFiltersListCodesProduct({
                    ...filtersListCodesProduct,
                    ProductCodeId: e ? e.value : null,
                  });
                }}
              />
            </div>
            <div className="col-3">
              <SelectCustom
                name="IsUsed"
                placeholder=" وضعیت استفاده "
                isClearable={true}
                isSearchable={false}
                unstyled={true}
                options={isUsedOptions}
                value={
                  isUsedOptions.find(
                    (item) => item.value === filtersListCodesProduct.IsUsed
                  ) || null
                }
                onChange={(e) => {
                  setFiltersListCodesProduct({
                    ...filtersListCodesProduct,
                    IsUsed: e ? e.value : null,
                  });
                }}
              />
            </div>
            <div className="col-3">
              <button
                style={{
                  color: "#ffff",
                  background: "#86a0ff",
                  border: "0px",
                  width: "108px",
                  height: "39px",
                  borderRadius: "8px",
                  padding: "2px",
                }}
                onClick={handleSearchClick}
              >
                جستجو
              </button>
            </div>
          </div>
          <DataTable
            value={listCodesProduct?.items}
            paginator
            lazy
            rows={filtersListCodesProduct.pageSize}
            totalRecords={listCodesProduct?.totalCount}
            first={
              (filtersListCodesProduct.pageNumber - 1) *
              filtersListCodesProduct.pageSize
            }
            onPage={handlePageChange}
            stripedRows
            className="farsi-monospace-digit"
          >
            <Column field="code" header="کد" />
            <Column
              header="وضعیت"
              body={(row) =>
                row.isUsed ? (
                  <span className="badge bg-success">استفاده شده</span>
                ) : (
                  <span className="badge bg-danger">استفاده نشده</span>
                )
              }
            />
            <Column
              header="استفاده کننده"
              body={(row) => row?.user?.name || "-"}
            />
            <Column
              header="شماره"
              body={(row) => row?.user?.phoneNumber || "-"}
            />
            <Column
              header="تاریخ استفاده"
              body={(row) =>
                row?.usedAt ? <PersianDate date={row.usedAt} /> : "-"
              }
            />
          </DataTable>
        </div>
      </div>
      {sidebarLeftShow && (
        <SidebarLeftAddCategoryCode
          showSuccess={showSuccess}
          onClose={() => setSidebarLeftShow(false)}
          refetchProductCode={refetchProductCode}
        />
      )}
    </div>
  );
};

export default Code;
